import { createRule, createWrappingJoinRule } from '@atlaskit/editor-common/utils';
import { WRAPPER_BLOCK_TYPES } from './block-types';
export var isNodeAWrappingBlockNode = function isNodeAWrappingBlockNode(node) {
  if (!node) {
    return false;
  }
  return WRAPPER_BLOCK_TYPES.some(function (blockNode) {
    return blockNode.name === node.type.name;
  });
};
export var createJoinNodesRule = function createJoinNodesRule(match, nodeType) {
  return createWrappingJoinRule({
    nodeType: nodeType,
    match: match,
    getAttrs: {},
    joinPredicate: function joinPredicate(_, node) {
      return node.type === nodeType;
    }
  });
};
export var createWrappingTextBlockRule = function createWrappingTextBlockRule(_ref) {
  var match = _ref.match,
    nodeType = _ref.nodeType,
    getAttrs = _ref.getAttrs;
  var handler = function handler(state, match, start, end) {
    var fixedStart = Math.max(start, 1);
    var $start = state.doc.resolve(fixedStart);
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    var nodeBefore = $start.node(-1);
    if (nodeBefore && !nodeBefore.canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) {
      return null;
    }
    return state.tr.delete(fixedStart, end).setBlockType(fixedStart, fixedStart, nodeType, attrs);
  };
  return createRule(match, handler);
};

/**
 * Function will create a list of wrapper blocks present in a selection.
 */
function getSelectedWrapperNodes(state) {
  var nodes = [];
  if (state.selection) {
    var _state$selection = state.selection,
      $from = _state$selection.$from,
      $to = _state$selection.$to;
    var _state$schema$nodes = state.schema.nodes,
      blockquote = _state$schema$nodes.blockquote,
      panel = _state$schema$nodes.panel,
      orderedList = _state$schema$nodes.orderedList,
      bulletList = _state$schema$nodes.bulletList,
      listItem = _state$schema$nodes.listItem,
      codeBlock = _state$schema$nodes.codeBlock,
      decisionItem = _state$schema$nodes.decisionItem,
      decisionList = _state$schema$nodes.decisionList,
      taskItem = _state$schema$nodes.taskItem,
      taskList = _state$schema$nodes.taskList;
    state.doc.nodesBetween($from.pos, $to.pos, function (node) {
      if (node.isBlock && [blockquote, panel, orderedList, bulletList, listItem, codeBlock, decisionItem, decisionList, taskItem, taskList].indexOf(node.type) >= 0) {
        nodes.push(node.type);
      }
    });
  }
  return nodes;
}

/**
 * Function will check if changing block types: Paragraph, Heading is enabled.
 */
export function areBlockTypesDisabled(state) {
  var nodesTypes = getSelectedWrapperNodes(state);
  var panel = state.schema.nodes.panel;
  return nodesTypes.filter(function (type) {
    return type !== panel;
  }).length > 0;
}